<template>
    <div>
        <modal :show.sync="addItem" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Agregar detalle</h6>
                <div class="form-group">
                    <label>Detalle *</label>
                    <fg-input   type="text"
                                name="detalle"
                                placeholder="detalle"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('detalle')"
                                v-model="itemName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Precio de compra</label>
                    <vue-numeric  :max=999999999999999 currency="$" autocomplete="off" name="precio de compra" v-validate="modelValidations.sales" :error="getError('precio de compra')" separator="." class="form-control" v-model="itemPurchasePrice"></vue-numeric>
                </div>
                
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelAddItem()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="addItemToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <card class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title">Agregar ítem</h6>
            </div>
            <div class="card-body">
                <div class="form-group">
                    <label>Nombre *</label>
                    <fg-input   type="text"
                                name="nombre"
                                placeholder="nombre"
                                autocomplete="off"
                                v-validate="modelValidations.product_name"
                                :error="getError('nombre')"
                                v-model="productName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Periodicidad *</label>
                    <fg-input   name="periodicidad"
                                v-validate="modelValidations.item_name"
                                :error="getError('periodicidad')"
                                v-model="productPeriodicity">
                            <el-select 
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="productPeriodicity">
                            <el-option 
                                    class="select-warning"
                                    value="Diaria"
                                    label="Diaria">
                            </el-option>
                            <el-option 
                                    class="select-warning"
                                    value="Semanal"
                                    label="Semanal">
                            </el-option>
                            <el-option 
                                    class="select-warning"
                                    value="Quincenal"
                                    label="Quincenal">
                            </el-option>
                            <el-option 
                                    class="select-warning"
                                    value="Mensual"
                                    label="Mensual">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <hr v-if="productPeriodicity != ''" class="hr-orange">
                <div v-if="productPeriodicity == 'Diaria'">
                    <label>Seleccione a continuación los días que trabaja en la semana</label>
                    <div class="row" style="margin: 0 0 12px;">
                        <p-checkbox v-model="checkboxes[0].value" :checked="false">L</p-checkbox>
                        <p-checkbox v-model="checkboxes[1].value" class="ml-2" :checked="false">M</p-checkbox>
                        <p-checkbox v-model="checkboxes[2].value" class="ml-2" :checked="false">M</p-checkbox>
                        <p-checkbox v-model="checkboxes[3].value" class="ml-2" :checked="false">J</p-checkbox>
                        <p-checkbox v-model="checkboxes[4].value" class="ml-2" :checked="false">V</p-checkbox>
                    </div>
                    <div class="row" style="margin: 0 0 12px;">
                            <p-checkbox v-model="checkboxes[5].value" :checked="false">S</p-checkbox>
                            <p-checkbox v-model="checkboxes[6].value" class="ml-2" :checked="false">D</p-checkbox>
                    </div>
                    <div v-if="workdaysComputed != 0" class="alert alert-warning">
                        <span>Trabaja {{workdaysComputed}} día(s) a la semana</span>
                    </div>
                    <div v-if="productPeriodicity != ''" class="alert alert-info mt-2">
                        <span>A continuación ingrese la cantidad de unidades producidas cada día</span>
                    </div>
                    <div class="row">
                        <div v-for="workday in checkboxesComputed" :key="workday.day" class="col-lg-3 col-md-4 col-sm-6 col-xs-6">
                            <div class="form-group">
                                <label>{{workday.day}}</label>
                                <vue-numeric  :max=999999999999999 currency="" autocomplete="off" :name="workday.day" v-validate="modelValidations.sales" :error="getError(workday.day)" separator="." class="form-control" v-model="workday.sales"></vue-numeric>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="productPeriodicity == 'Semanal'">
                    <div v-if="productPeriodicity != ''" class="alert alert-info mt-2">
                        <span>A continuación ingrese la cantidad de unidades producidas cada semana</span>
                    </div>
                    <div v-for="weekday in weeks" :key="weekday.week" class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <div class="form-group">
                            <label>Semana {{weekday.week}}</label>
                            <vue-numeric  :max=999999999999999 currency="" autocomplete="off" :name="weekday.week" v-validate="modelValidations.sales" :error="getError(weekday.week)" separator="." class="form-control" v-model="weekday.sales"></vue-numeric>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="productPeriodicity == 'Quincenal'">
                    <div v-if="productPeriodicity != ''" class="alert alert-info">
                        <span>A continuación ingrese la cantidad de unidades producidas cada quincena</span>
                    </div>
                    <div v-for="biweek in biweeks" :key="biweek.biweek" class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <div class="form-group">
                            <label>Quincena {{biweek.biweek}}</label>
                            <vue-numeric  :max=999999999999999 currency="" autocomplete="off" :name="biweek.biweek" v-validate="modelValidations.sales" :error="getError(biweek.biweek)" separator="." class="form-control" v-model="biweek.sales"></vue-numeric>
                        </div>
                    </div>
                </div>
                <div v-if="productPeriodicity == 'Mensual'">
                    <div v-if="productPeriodicity != ''" class="alert alert-info mt-2">
                        <span>A continuación ingrese la cantidad de unidades producidas en el mes</span>
                    </div>
                    <div class="form-group">
                        <label>Mes</label>
                        <vue-numeric  :max=999999999999999 currency="" autocomplete="off" name="mes" v-validate="modelValidations.sales" :error="getError('mes')" separator="." class="form-control" v-model="productMonth"></vue-numeric>
                    </div>
                </div>
                <hr v-if="productPeriodicity != ''" class="hr-orange">
                <div class="form-group">
                    <label>Promedio producción *</label>
                    <fg-input   disabled
                                type="number"
                                name="promedio mes"
                                placeholder="promedio mes"
                                autocomplete="off"
                                v-validate="modelValidations.sales"
                                :error="getError('promedio mes')"
                                v-model="monthlyAverageComputed">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Precio de venta unitario *</label>
                    <vue-numeric  :max=999999999999999 currency="$" autocomplete="off" name="precio de venta" v-validate="modelValidations.sales" :error="getError('precio de venta')" separator="." class="form-control" v-model="productSaleValue"></vue-numeric>
                </div>
                <!--<div class="form-group">
                    <label>Tipo de costeo de insumos *</label>
                    <fg-input   tabindex="3"
                                name="tipo de costeo"
                                v-validate="modelValidations.product_name"
                                :error="getError('tipo de costeo')"
                                v-model="productSelect">
                            <el-select 
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="productSelect">
                            <el-option class="select-warning"
                                    value="unit"
                                    label="Individual">
                            </el-option>
                            <el-option class="select-warning"
                                    value="total"
                                    label="Total">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>-->
                <div v-if="productTotalSaleComputed != 0" class="alert alert-warning mt-2">
                    <span>Total venta mes: {{ setFormat(productTotalSaleComputed)}}</span>
                </div>
            </div>
            <div class="card-footer">
            </div>
        </card>
        <div class="text-right">
            <p-button v-if="productTotalSaleComputed != 0" @click="saveCosts()" type="warning">Siguiente</p-button>
            <p-button @click="toGeneralCosts()" type="default" class="pull-left mb-3">Atrás</p-button>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue'
    import { Card, Collapse, CollapseItem, Modal } from 'src/components/UIComponents'
    import PSwitch from 'src/components/UIComponents/Switch.vue'
    import VueNumeric from 'vue-numeric'
    import formatMoney from 'accounting-js/lib/formatMoney.js'
    import {Select, Option} from 'element-ui'
    Vue.use(Select)
    Vue.use(Option)
    export default {
        components: {
            Card,
            PSwitch,
            VueNumeric,
            Collapse,
            CollapseItem,
            Modal
        },
        data() {
        return {
            form: {
                average_selection: '',
            },
            itemName: '',
            itemPurchasePrice: '',
            productName: '',
            productPeriodicity: '',
            productSaleValue: '',
            productMonth: '',
            productSaleMonthly: '',
            productTotalSale: '',
            productCostPercent: 0,
            productPartPercent: 0,
            productSelect: 'total',
            productMultiplier: 1,
            productUnitCosting: 0,
            productSalesCosting: 0,
            productTotalCosting: 0,
            productTotalCost: 0,
            productUnitCost: 0,
            addItem: false,
            items: [
                
            ],
            checkboxes: [
                {
                    day: "Lunes",
                    char: "L",
                    value: true,
                    sales: ''
                },
                {
                    day: "Martes",
                    char: "M",
                    value: true,
                    sales: ''
                },
                {
                    day: "Miércoles",
                    char: "M",
                    value: true,
                    sales: ''
                },
                {
                    day: "Jueves",
                    char: "J",
                    value: true,
                    sales: ''
                },
                {
                    day: "Viernes",
                    char: "V",
                    value: true,
                    sales: ''
                },
                {
                    day: "Sábado",
                    char: "S",
                    value: true,
                    sales: ''
                },
                {
                    day: "Domingo",
                    char: "D",
                    value: true,
                    sales: ''
                },
            ],
            weeks: [
                {
                    week: '1',
                    sales: ''
                },
                {
                    week: '2',
                    sales: ''
                },
                {
                    week: '3',
                    sales: ''
                },
                {
                    week: '4',
                    sales: ''
                }
            ],
            biweeks: [
                {
                    biweek: '1',
                    sales: ''
                },
                {
                    biweek: '2',
                    sales: ''
                }
            ],
            modelValidations: {
                sales: {
                    required: false
                },
                item_name: {
                    required: false,
                    max: 32
                },
                product_name: {
                    required: false,
                    max: 32
                },
                sales: {
                    required: false,
                    max: 32
                },
                average_selection: {
                    required: false
                },
                
            },
        }
        },
        watch: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productPeriodicity: function (val) {
                for (let i=0;i<this.checkboxes.length;i++) {
                    this.checkboxes[i].value = true;
                    this.checkboxes[i].sales = '';
                };
                for (let i=0;i<this.weeks.length;i++) {
                    this.weeks[i].sales = '';
                };
                for (let i=0;i<this.biweeks.length;i++) {
                    this.biweeks[i].sales = '';
                };
                this.productMonth = '';
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productSelect: function(val) {
                if (val == 'unit') {
                    this.productMultiplier = this.productSaleMonthly;
                }
                else {
                    this.productMultiplier = 1;
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productLinePurchaseCost: function (val) {
                if (val != 0) {
                    if (this.productLineMonthly != 0) {
                        this.productLineTotal = parseFloat(val) * parseFloat(this.productLineMonthly);
                        this.productLineTotalFormat = this.setFormat(this.productLineTotal);
                        this.productLinePurchaseCostFormat = this.setFormat(val);
                    }
                }
                else {
                    this.productLineTotal = 0;
                    this.productLineTotalFormat = 0;
                    this.productLinePurchaseCostFormat = 0;

                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productLineMonthly: function (val) {
                if (val != 0) {
                    if (this.productLinePurchaseCost != 0) {
                        this.productLineTotal = parseFloat(val) * parseFloat(this.productLinePurchaseCost)
                    }
                }
                else {
                    this.productLineTotal = 0;
                }
            }
            
        },
        computed: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            monthlyAverageComputed () {
                var sum = 0;
                var total = 0;
                if (this.productPeriodicity == 'Diaria') {
                    for (var i=0; i<this.checkboxesComputed.length; i++) {
                        if (this.checkboxesComputed[i].sales != '') {
                            sum = sum + parseFloat(this.checkboxesComputed[i].sales)
                            total = sum * 4
                        }
                    }
                }
                else if (this.productPeriodicity == 'Semanal') {
                    for (var i=0; i<this.weeks.length; i++) {
                        if (this.weeks[i].sales != '') {
                            sum = sum + parseFloat(this.weeks[i].sales)
                            total = sum
                        }
                    }
                }
                else if (this.productPeriodicity == 'Quincenal') {
                    for (var i=0; i<this.biweeks.length; i++) {
                        if (this.biweeks[i].sales != '') {
                            sum = sum + parseFloat(this.biweeks[i].sales)
                            total = sum
                        }
                    }
                }
                else if (this.productPeriodicity == 'Mensual') {
                    total = this.productMonth;
                }
                this.productSaleMonthly = total;
                return total;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            workdaysComputed () {
                return this.checkboxes.filter(day => day.value == true).length;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            checkboxesComputed () {
                return this.checkboxes.filter(day => day.value == true);
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productTotalSaleComputed () {
                var total = this.productSaleMonthly * this.productSaleValue;
                this.productTotalSale = total;
                return total;

            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            costsMonthlyLine () {
                return 5000;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            salesMonthlyAverage () {
                var avg = 0;
                var sum = 0;
                for (var i=0;i<this.items.length;i++) {
                    sum = sum + this.items[i].itemPercent;
                }
                avg = sum / this.items.length;
                return Math.round(avg);
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            validateGeneralCosts () {
                if(this.productLineName && this.productLinePurchaseCost != 0 && this.productLineMonthly && (this.items.length >= 3 && this.items.length <= 5)) {
                    return true
                }
                else {
                    return false
                }
            },
            
        },
        methods: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationError (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-glasses-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationSuccess (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-check-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'success'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addItemToList () {
                if (this.itemName == '' || this.itemPercent == 0) {
                    this.showNotificationError('El campo nombre de ítem y porcentaje no pueden estar vacíos');
                }
                else {
                    this.items.push({
                        itemName: this.itemName,
                        itemPurchasePrice: this.itemPurchasePrice,
                        itemSalePrice: this.itemSalePrice,
                        itemPercent: this.itemPercent
                    })
                    this.resetItem();
                    this.addItem = false;
                    this.showNotificationSuccess('Producto agregado correctamente');
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            removeItem () {
                this.items.splice(this.items.length-1,1);
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetItem () {
                this.itemName= '',
                this.itemPurchasePrice= '',
                this.itemSalePrice= '',
                this.itemPercent= ''
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addItemMethod () {
                this.addItem = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddItem () {
                this.addItem = false;
                this.resetItem();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            dailySelectValidation () {
                if (this.checkboxes.filter(day => day.value == true).length) {
                    return false
                }
                else {
                    return true
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            setFormat (value) {
                return formatMoney(value, { symbol: "$", precision: 0, thousand: ".", decimal: "," });
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            getError (fieldName) {
                return this.errors.first(fieldName)
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            validateSwitch () {
                if(this.switches.daily || this.switches.weekly || this.switches.monthly || this.switches.product || this.switches.average) {
                    return true
                }
                else {
                    return false
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toGeneralCosts () {
                this.$router.push('/asessments/new_asessment/customer/costs/production/item');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            saveCosts () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.productName != '') {
                            this.$store.dispatch('setCostsProductionItem', this.$data).then(()=>{
                                this.$router.push('/asessments/new_asessment/customer/costs/production/item');
                            });    
                        }
                        else {
                            this.showNotificationError('El campo nombre de ítem no puede estar vacío');
                        }
                    }
                })
            }
        },
        mounted () {
        }
    }
</script>
<style>
hr.hr-orange {
    border-top: 1px dashed orange;
}
</style>
